import has from 'lodash/has';

/**
 * @param {string} key
 * @param {ColorMap} colorMapper
 * @return {string} color
 */
function getColorForSet (key, colorMapper) {
  if (has(colorMapper, key)) {
    return colorMapper[key];
  }
  return colorMapper.default;
}
export default getColorForSet;
